package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

sealed interface ToolbarActionVisibility {
    data object Always : ToolbarActionVisibility
    data object DebugOnly : ToolbarActionVisibility
    data object Never : ToolbarActionVisibility

    /**
     * For cases like: `thisIsMyPhone || BuildConfig.DEBUG`
     */
    data class Predicate(val isVisible: () -> Boolean) : ToolbarActionVisibility
}
